import type { LegKind } from "./types";

export const LEG_KINDS: LegKind[] = ["feed", "traveler", "switched", "load"];

/** What a Wechselschaltung's run between the switches usually is: two travellers, N and PE. */
export const TRAVELER_SUGGESTION = "NYM-J 5x1,5";
